import React from 'react'
import { Footer, Header, } from '../../container'
import {Navbar} from '../../components'
import {motion} from 'framer-motion'
const AboutBakery = React.lazy(() => import('../../container/AboutBakery/AboutBakery')) 
const Gallery = React.lazy(() => import('../../container/Gallery/Gallery')) 
const SpecialMenu = React.lazy(() => import('../../container/Menu/SpecialMenu')) 
const Intro = React.lazy(() => import('../../container/Intro/Intro'))
const FindUs = React.lazy(() => import('../../container/Findus/FindUs')) 

function Home() {
  return (
    <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}>
         <Navbar />
        <Header />
        {/* <AboutUs /> */}
        <AboutBakery />
        <SpecialMenu />
        {/* <Chef /> */}
        <Intro />
        {/* <Laurels /> */}
        <Gallery />
        <FindUs />
        <Footer />
    </motion.div>
  )
}

export default Home